import { BillingView } from "@/pages/Billing";

export default function AdminBilling() {
  return <BillingView admin />;
}
